import { styled } from '@mui/material';

const PREFIX = 'DropDown';

export const classes = {
  dropdown: `${PREFIX}-dropdown`,
};

export const Root = styled('div')(({ theme }) => ({
  [`& .${classes.dropdown}`]: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    position: 'absolute' as const,
    visibility: 'hidden' as const,
    opacity: 0,
    transform: 'translateX(-10px)',
    transition: 'opacity 0.5s, transform 0.25s',
    zIndex: 3,
  },
}));